import { render } from "./ClientsListShowModal.vue?vue&type=template&id=cf10c0be"
import script from "./ClientsListShowModal.vue?vue&type=script&lang=js"
export * from "./ClientsListShowModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__